import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdExternalApiTest_connection = z.any()
export type TagsGetMunicipalities_municipalityIdExternalApiTest_connection = z.infer<typeof tagsGetMunicipalities_municipalityIdExternalApiTest_connection>

export const descriptionGetMunicipalities_municipalityIdExternalApiTest_connection = z.any()
export type DescriptionGetMunicipalities_municipalityIdExternalApiTest_connection = z.infer<typeof descriptionGetMunicipalities_municipalityIdExternalApiTest_connection>

export const paramsGetMunicipalities_municipalityIdExternalApiTest_connection = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdExternalApiTest_connection = z.infer<typeof paramsGetMunicipalities_municipalityIdExternalApiTest_connection>

export const querystringGetMunicipalities_municipalityIdExternalApiTest_connection = z.object({ "externalConnectionId": z.string().uuid() })
export type QuerystringGetMunicipalities_municipalityIdExternalApiTest_connection = z.infer<typeof querystringGetMunicipalities_municipalityIdExternalApiTest_connection>

export const responseGetMunicipalities_municipalityIdExternalApiTest_connection = z.object({ "success": z.boolean(), "message": z.string() })
export type ResponseGetMunicipalities_municipalityIdExternalApiTest_connection = z.infer<typeof responseGetMunicipalities_municipalityIdExternalApiTest_connection>

interface IGetMunicipalities_municipalityIdExternalApiTest_connection extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdExternalApiTest_connection,
  description: DescriptionGetMunicipalities_municipalityIdExternalApiTest_connection,
  params: ParamsGetMunicipalities_municipalityIdExternalApiTest_connection,
  querystring: QuerystringGetMunicipalities_municipalityIdExternalApiTest_connection,
  response: ResponseGetMunicipalities_municipalityIdExternalApiTest_connection
}
export const URL = '/municipalities/:municipalityId/externalApi/test-connection'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdExternalApiTest_connection,
    description: descriptionGetMunicipalities_municipalityIdExternalApiTest_connection,
    params: paramsGetMunicipalities_municipalityIdExternalApiTest_connection,
    querystring: querystringGetMunicipalities_municipalityIdExternalApiTest_connection,
    response: responseGetMunicipalities_municipalityIdExternalApiTest_connection
  }
}
export interface Municipalities_municipalityIdExternalApiTest_connection extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdExternalApiTest_connection
}